import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output, inject } from '@angular/core';
import { ENUM_PropertyInvestmentType } from '@api-new/common';
import { provideComponentStore } from '@ngrx/component-store';
import { ButtonWithImageComponent } from '@shared-lib/components/button-with-image/button-with-image.component';
import { HasCompanyClientUiSettingsEnabledDirective } from '@shared/directives/has-company-client-ui-settings-enabled.directive';
import { CompanyClientUISettingsKey } from '@shared/services/company-client-ui-settings.service';
import { AddNewPortfolioItemStore } from './add-new-portfolio-item.store';

@Component({
  selector: 'cp-add-new-portfolio-item',
  imports: [CommonModule, ButtonWithImageComponent, HasCompanyClientUiSettingsEnabledDirective],
  templateUrl: './add-new-portfolio-item.component.html',
  styleUrl: './add-new-portfolio-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideComponentStore(AddNewPortfolioItemStore)],
})
export class AddNewPortfolioItemComponent {
  private readonly componentStore = inject(AddNewPortfolioItemStore);

  protected readonly ENUM_PropertyInvestmentType = ENUM_PropertyInvestmentType;
  protected readonly showSmartSearchKey: CompanyClientUISettingsKey = 'showSmartSearch';

  @Output() redirectClicked = new EventEmitter<void>();

  addProperty(propertyType: ENUM_PropertyInvestmentType): void {
    this.componentStore.redirectToAddProperty(propertyType);
    this.redirectClicked.emit();
  }

  openSmartSearch(): void {
    this.componentStore.openAddSmartSearchDialog();
    this.redirectClicked.emit();
  }
}
